// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1203":"3a78d236","3047":"3a78d236","4598":"3a78d236","7968":"3a78d236"}[chunkId] + ".chunk.css";
};